export default interface Dashboard {
    id: number;
    schoolId: number;
    banner?: DashboardBanner;
    widgets: DashboardWidget[];
}

interface DashboardBanner {
    id: number;
    token?: string;
    style?: string;
    colour?: string;
    enabled: boolean;
}

export enum DashboardWidgetType {
    Contacts = "Contacts",
    Urls = "Urls",
    Files = "Files",
    Activities = "Activities",
}

export interface DashboardWidget {
    id: number;
    type: DashboardWidgetType;
    name: string;
    description: string;
    enabled: boolean;
    contacts?: DashboardWidgetContact[];
    files?: DashboardWidgetFile[];
    urls?: DashboardWidgetUrl[];
    
}

export interface DashboardWidgetContact {
    id: number;
    type: string;
    personID: number;
}

export interface DashboardWidgetFile {
    id: number;
    fileName: string;
    displayName: string;
    storageToken?: string;
    data?: string;
    removed?: boolean;
}

export interface DashboardWidgetUrl {
    id: number;
    url: string;
    urlName: string;
    urlDescription: string;
}

export interface DashboardActivity {
    name: string;
    activityStart: string;
    activityEnd: string;    
}

export interface DashboardContact {
    type: string;
    name: string;
    code: string;
    firstName: string;
    lastName: string;
    contact: string;
}